import { Layout } from 'components/atoms'
import { InputBuild, SelectBuild } from 'components/molecules'
import { FormThirdGuarantorProps } from 'pages/Contracts/Components/Forms/FormThirdGuarantor/interfaces'
import React, { useMemo } from 'react'
import { useFormContext } from 'react-hook-form'
import { ViewThirdGuarantorValue } from './form'

const ViewThirdGuarantorForm: React.FC = () => {
    const { register, watch } = useFormContext<{
        terceiroGarantidor: FormThirdGuarantorProps
    }>()

    const form = useMemo(() => ViewThirdGuarantorValue(), [])

    return (
        <Layout full type="container" display="grid" gap={8}>
            <Layout type="row" gutter={{ y: 1.5 }}>
                {form.map(({ layout, input, select }, key) => (
                    <Layout {...layout} key={key}>
                        {select ? (
                            <SelectBuild
                                {...select}
                                {...register(`terceiroGarantidor.${select.id}`)}
                                value={
                                    watch(
                                        `terceiroGarantidor.${select.id}`
                                    ) as string
                                }
                                isDisable={true}
                            />
                        ) : (
                            input && (
                                <InputBuild
                                    {...input}
                                    {...register(`terceiroGarantidor.${input.id}`)}
                                    value={
                                        watch(
                                            `terceiroGarantidor.${input.id}`
                                        ) as string
                                    }
                                    isDisable={true}
                                />
                            )
                        )}
                    </Layout>
                ))}
            </Layout>
        </Layout>
    )
}

export default ViewThirdGuarantorForm